module.exports = __webpack_public_path__ + "media/images/landing_page/escrow_dashboard-9c2a8ccccd10cdf4a388c040bc8bbe3c.png";